import { RevisionPrompt } from 'components/AIRevision/RevisionPrompt'
import { useState } from 'react'
import Styles from './CompleteActions.module.scss'
import cx from 'classnames'
import { RetryIconButton } from 'components/AIRevision/RetryIconButton'
import { Revision } from 'types'
import { EditorView } from 'prosemirror-view'
import { useFocusWithin } from '@react-aria/interactions'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

export interface Props {
  articleId: string
  layerId: string
  customPrompt: string
  onPromptChange: (prompt: string) => any
  revision: Revision
  view: EditorView
}

export const FailedActions = ({ articleId, layerId, revision, view, customPrompt, onPromptChange }: Props) => {
  const hasPrompt = customPrompt.trim().length > 0
  const [isRevisionPromptFocused, setIsRevisionPromptFocused] = useState(false)
  const { isMobile } = useResponsiveDesign()

  const { focusWithinProps } = useFocusWithin({
    onFocusWithinChange: (isFocusWithin) => setIsRevisionPromptFocused(isFocusWithin),
  })

  const isActive = hasPrompt && isRevisionPromptFocused

  return (
    <>
      <div className={cx(Styles.promptContainer)} {...focusWithinProps}>
        <RevisionPrompt
          articleId={articleId}
          layerId={layerId}
          isActive
          customPrompt={customPrompt}
          onChange={onPromptChange}
          menuOffsetOptions={{ mainAxis: 16, crossAxis: -42 }}
          submitIconSize={isMobile ? 'lg' : 'sm'}
          inputSize="md"
        />
      </div>
      <ResponsiveDesign.Desktop>
        <div className={cx(Styles.buttonContainer, { [Styles.promptActive]: isActive })}>
          <RetryIconButton revision={revision} view={view} />
        </div>
      </ResponsiveDesign.Desktop>
    </>
  )
}
